// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__200bt","pricing":"styles_pricing__1myVo","column-content":"styles_column-content__1AZsh","infinity":"styles_infinity__2qtT6"};